
    import '/Users/jilin/projects/antd/rc-dialog/docs/demo/draggable.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-demo-draggable-demo-draggable"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/jilin/projects/antd/rc-dialog/docs/demo/draggable.md?type=demo')
};